/* eslint-disable react/no-did-update-set-state */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { SearchResultLiveRegion } from '@bingads-webui-react/search-box';
import { curlyTemplate } from '@bingads-webui-universal/primitive-utilities';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { ListSelector } from '@bingads-webui-react/list-selector';
import { getDefaultGlobalSearchStyles } from '@bingads-webui-react/global-search';
import { getHelpLibraryResults } from './utility';

class HelpLibraryResultView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      helpLibraryResults: [],
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchQuery !== prevProps.searchQuery) {
      const helpLibraryResults = getHelpLibraryResults({
        query: this.props.searchQuery,
      });

      this.setState({
        helpLibraryResults,
      });
    }
  }

  onSelect = (item, index, event) => {
    const { video } = item;
    if (!video) {
      return;
    }

    if (window.ApexVideoHandler && _.isFunction(window.ApexVideoHandler.ShowVideo)) {
      window.ApexVideoHandler.ShowVideo(event);
    }
  };

  getHelpLibraryListView = () => {
    const { searchQuery, searchResultsNum, i18n } = this.props;

    const {
      renderItem,
      renderHeader,
      renderDivider,
      renderNoResults,
      onSelect,
    } = this;

    const { helpLibraryResults } = this.state;
    const data = helpLibraryResults.map(item => [item, { type: 'divider' }]).reduce((a, b) => a.concat(b), []);

    if (searchQuery === '') {
      return null;
    }
    const limit = searchResultsNum * 2;

    const ariaLabel = i18n.getString(_TL_('Help search result list'));

    return (
      <div>
        <ListSelector
          renderHeader={renderHeader}
          renderItem={renderItem}
          renderDivider={renderDivider}
          onSelect={onSelect}
          data={data.length > limit ? _.first(data, limit) : data}
          enableArrowKeysSupport
          ariaLabel={ariaLabel}
        />
        {searchQuery && data.length === 0 && renderNoResults(searchQuery, ariaLabel)}
      </div>
    );
  };

  renderItem = (item) => {
    const { classes } = this.props;
    const { suggestion, video, url } = item;
    let [videoid, opVideoid] = video.split('~');
    const videoEnabled = videoid && opVideoid;
    const itemClassName = videoEnabled ? 'abLaunchVideo' : 'HelpTopic';
    videoid = videoEnabled ? videoid : null;
    opVideoid = videoEnabled ? opVideoid : null;
    const isNumeric = url.toUpperCase() === url.toLowerCase();
    let query = null;
    if (!videoEnabled) {
      query = isNumeric ? `help:ext${url}` : `help:${url}`;
    }

    return (
      <div
        className={classnames(classes.searchResultItem, 'help-library-search-result-item')}
      >
        <div className={classes.searchItemContainer}>
          <div className={classnames(classes.searchItemSpan, 'help-library-search-result-text')} >
            <span
              className={itemClassName}
              videoid={videoid}
              op_videoid={opVideoid}
              query={query}
              title={suggestion}
            >
              {suggestion}
            </span>
          </div>
        </div>
      </div>
    );
  };

  renderNoResultsListItem = (query) => {
    const { classes, i18n } = this.props;
    return (
      <div
        className={classnames(classes.searchResultItem, 'help-library-result-item')}
      >
        <div className={classes.searchItemContainer}>
          <div className={classes.searchItemSpan}>
            <span>{curlyTemplate(i18n.getString(_TL_('No results found for {{searchText}}')))({
              searchText: query,
            })}
            </span>
          </div>
        </div>
      </div>
    );
  };

  renderNoResults = (query, ariaLabel) => (
    <ListSelector
      renderHeader={_.noop}
      renderItem={() => this.renderNoResultsListItem(query)}
      renderDivider={_.noop}
      onSelect={_.noop}
      data={[{}]}
      ariaLabel={ariaLabel}
    />
  );

  renderHeader = () => {
    const { classes, i18n } = this.props;

    return (
      <div className={classnames(classes.resultHeaderContainer, 'help-library-search-result-section-header')}>
        <span className={classes.resultHeader}>
          {i18n.getString(_TL_('Help articles: '))}
        </span>
      </div>
    );
  };

  renderDivider = (item, index, key) => {
    const { classes } = this.props;
    return (
      <div
        className={classnames(classes.divider, 'global-search-divider')}
        key={key}
      />
    );
  };

  render() {
    const {
      classes,
      i18n,
      searchQuery,
    } = this.props;

    const searchResultItemCount = this.state.helpLibraryResults.length;

    return (
      <div className={classes.searchResultDropDown}>
        {this.getHelpLibraryListView()}
        <SearchResultLiveRegion
          totalCount={searchResultItemCount}
          emptyText={curlyTemplate(i18n.getString(_TL_('No results found for {{searchText}}')))({
            searchText: searchQuery,
          })}
          resultText={curlyTemplate(i18n.getString(_TL_('Found {{totalCount}} Results for {{searchText}}')))({
            totalCount: searchResultItemCount,
            searchText: searchQuery,
          })}
        />
      </div>
    );
  }
}

HelpLibraryResultView.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getDefaultGlobalSearchStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  searchQuery: PropTypes.string.isRequired,
  searchResultsNum: PropTypes.number,
};

HelpLibraryResultView.defaultProps = {
  searchResultsNum: 4,
};

export const StyledHelpLibraryResultView = withI18nConsumer(withDefaultStyles(
  HelpLibraryResultView,
  getDefaultGlobalSearchStyles
));

// eslint-disable-next-line react/prop-types
export const renderHelpLibrarySearch = ({ searchQuery, i18n, searchResultsNum }) => (
  <StyledHelpLibraryResultView
    searchQuery={searchQuery}
    i18n={i18n}
    searchResultsNum={searchResultsNum}
    key="help-library-result-view"
  />
);
